(async () => {
    if (!customElements.get("features-prowand")) {
        class FeaturesProwand extends HTMLElement {
            constructor() {
                super();
                this.swiperElement = this.querySelector("[data-features-prowand-swiper]");
                this.swiperOptions = {
                    autoplay: false,
                    slidesPerView: 3.5,
                    observer: false,
                    threshold: 10,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.5,
                            spaceBetween: 15,
                        },
                        700: {
                            slidesPerView: 2.5,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2.5,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 2.6,
                            spaceBetween: 20,
                        },
                        1440: {
                            slidesPerView: 3.6,
                            spaceBetween: 20,
                        },
                        2400: {
                            slidesPerView: 5.5,
                            spaceBetween: 20,
                        },
                    },
                    on: {
                        init: () => {
                            // Pause autoplay on hover
                            this.swiperElement.addEventListener("mouseenter", () => {
                                this.swiperInstance.autoplay.stop();
                            });
                            // Resume autoplay on mouse leave
                            this.swiperElement.addEventListener("mouseleave", () => {
                                this.swiperInstance.autoplay.start();
                            });
                        },
                    },
                };

                // Check if we have extra options on the HTML
                if (this && this.dataset && this.dataset.options) {
                    const jsonOptions = JSON.parse(this.dataset.options);
                    if (jsonOptions) {
                        this.swiperOptions = {
                            ...this.swiperOptions,
                            ...jsonOptions,
                        };
                    }
                }

                // re-init slider when Theme Editor is active
                if (Shopify.designMode && this.swiperInstance) {
                    window.addEventListener("shopify:section:load", () => {
                        this.swiperInstance.update();
                    });
                }
                this.init();
            }

            init() {
                this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
            }
        }

        window.FeaturesProwand = FeaturesProwand;

        customElements.define("features-prowand", FeaturesProwand);
    }
   
})();